module.exports = __webpack_public_path__ + "static/img/mole.92e663f3.png";